import { useLogger } from "@amzn/xb-hooks";
import { useContext } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { LiveContext } from "./LiveContext";
import { RemoteComponent, RemoteComponentProps } from "./RemoteComponent";
import { usePropMerge } from "./usePropMerge";

const warningMessage = (tier: number) => `
PageComponent should only be used as a tier 1 component (called from tier 0).
This component was called from ${tier}. Did you mean to use LiveComponent?
`;

/**
 * Page components are t1 Live Components that have a few "special" properties.
 *
 * One such special property is it fetches the dynamic segments and pass them
 * down to all descendant Live Components.
 */
export const PageComponent = ({
  props,
  fieldOverrideAllowList: allowedCollisions = [],
  ...rest
}: RemoteComponentProps) => {
  const { tier } = useContext(LiveContext);
  const { log } = useLogger();
  const pathParams = useParams<Record<string, string>>();
  const [queryParams] = useSearchParams();
  const liveProps = usePropMerge(
    { allowedCollisions },
    pathParams,
    Object.fromEntries(queryParams.entries()),
    props || {}
  );

  if (tier !== 0) {
    log.warn(warningMessage(tier));
  }

  return (
    <LiveContext.Provider value={{ tier: tier + 1, liveProps }}>
      <RemoteComponent props={liveProps} {...rest} />
    </LiveContext.Provider>
  );
};
